import { recurrenceTypes, monthlyOptionsTypes } from '../constants';
import {
  cronPlaces,
  convertCronExprToUTCMoment,
  getUTCTimeObjFromLocalMoment
} from './';

export const getOptionsFromCronExpression = cronExpression => {
  let options = {
    recurrenceType: recurrenceTypes.DAILY
  };

  if (!cronExpression) {
    options.recurrenceType = recurrenceTypes.NONE;
    return options;
  }

  let cronExpressionArr = cronExpression.split(' ');
  let monthPlace = cronExpressionArr[cronPlaces.MONTHLY];
  let weekPlace = cronExpressionArr[cronPlaces.WEEKLY];

  if (monthPlace !== '*' && monthPlace !== '?') {
    options = getMonthOptions(monthPlace);
  }

  if (weekPlace !== '*' && weekPlace !== '?') {
    options = getWeekOptions(weekPlace);
  }

  options.time = getUTCTimeObjFromLocalMoment(
    convertCronExprToUTCMoment(cronExpression)
  );

  return options;
};

const getWeekOptions = value => {
  let options = {};

  options.recurrenceType = recurrenceTypes.WEEKLY;

  options.value = value.split(',');
  return options;
};

const getMonthOptions = value => {
  let options = {};

  options.recurrenceType = recurrenceTypes.MONTHLY;

  if (value.includes('L-')) {
    options.modifier = monthlyOptionsTypes.DAYS_BEFORE_END;
    options.value = value.split('-')[1];
    return options;
  }

  if (value.includes('L')) {
    options.modifier = monthlyOptionsTypes.LAST_DAY;
    return options;
  }

  options.modifier = monthlyOptionsTypes.ON_DAY;
  options.value = value;
  return options;
};
